import { FetchingActionType, PersistItemsActionType } from 'features/Persist/actionTypes';
import { PersistItemsReducer } from 'features/Persist/reducerTypes';
import { MeetingStatusResponse } from 'services/tenantManagementService';
import { MEETING_STATUS_FETCHING, MEETING_STATUS_SET } from './action';

export const meetingStatusReducer = (state = new PersistItemsReducer<MeetingStatusResponse>(), action: PersistItemsActionType<MeetingStatusResponse> | FetchingActionType): PersistItemsReducer<MeetingStatusResponse> => {
	switch (action.type) {
		case MEETING_STATUS_FETCHING:
			const { fetching } = action as FetchingActionType;

			return {
				...state,
				fetching
			}
		case MEETING_STATUS_SET:
			const { items } = action as PersistItemsActionType<MeetingStatusResponse>;

			const itemsMap: { [id: number]: MeetingStatusResponse } = items.reduce(
                (map: { [id: number]: MeetingStatusResponse }, item) => {
					map[item.id] = item;
					return map;
				},
                {}
			);

			return {
				items,
				itemsMap,
				fetching: false,
				isInitialized: true
			}
		default:
			return state;
	}
};
